import React from "react";
import Pagination from '@mui/material/Pagination';

import { useSelector } from 'react-redux';
import { PptosListaitem } from '../pptos/pptosListaItem';

import '../../assets/style/tablesG.css';

export const ListTables = ({ listaTitulos = [], filters, setFilters, totalCount, loading = false, error = false }) => {

    const { access } = useSelector(state => state.auth)
    const { list } = useSelector(state => state.ppto)

    const handleChange = (event, value) => {
        console.log(value)
        const newFilters = {
            ...filters,
            page: value
        }
        setFilters(newFilters)
    }

    return (
        <div className='p-table'>

            <div className="flex justify-between items-center">
                {totalCount > 0 ? (
                    <div className="ms-2 text-gray-500">
                        {totalCount || 0} proyectos encontrados
                    </div>
                ) : (
                    <div></div>
                )}

                {/* <Pagination
                    count={10}
                    page={page}
                    size="small"
                    onChange={handleChange}
                /> */}

                <Pagination
                    count={totalCount == null ? 10 : Math.max(1, Math.ceil(totalCount / filters.rows))}
                    page={Number(filters.page) || 1}
                    disabled={loading || error || totalCount === 0}
                    size="small"
                    onChange={handleChange}
                />

            </div>

            {/* <div className="row">
                <div className="col d-flex justify-content-end">
                    <Pagination
                        count={totalCount == null ? 10 : Math.max(1, Math.ceil(totalCount / filters.rows))}
                        page={Number(filters.page) || 1}
                        disabled={loading || error || totalCount === 0}
                        size="small"
                        onChange={handleChange}
                    />
                </div>
            </div> */}

            <div className="overflow-x-auto">
                <table className="table p-table-global">
                    <thead className='p-thead-global'>
                        <tr className="text-center p-tr-titles-global">
                            <th>Número</th>
                            <th>Fecha</th>
                            <th className="text-start sticky left-0 z-10 bg-white">Referencia</th>
                            <th className="text-start">Cliente</th>
                            <th className="text-end">Total neto</th>
                            {access.a21 && <th>Rentabilidad</th>}
                            <th>Ejecutivo</th>
                            <th>Creado por</th>
                            <th>Últ. Modificación</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading || error ? <tr><td colSpan={access.a21 ? 9 : 8} className="text-center py-4">{error ? 'No se pudieron cargar los presupuestos.' : 'Consultando presupuestos…'}</td></tr> : list.map(p => (
                            <PptosListaitem
                                p={p}
                                key={p.id}
                                access={access}
                            />
                        ))
                        }
                    </tbody>
                </table>
            </div>


        </div>
    )
}
